import { Distance } from 'shared/src/util/unit/distance'
import { Volume } from 'shared/src/util/unit/volume'
import type { DtoInsideDevice, ProcessedInsideDevice, ProcessedComputedStorage } from 'whats_inside/src/model'

export class DeviceDataProcessor {
  static process(device: DtoInsideDevice): ProcessedInsideDevice {
    return {
      ...device,
      lastMetering: this.processLastMetering(device.lastMetering),
      computed: this.processComputed(device.computed),
    }
  }

  private static processLastMetering(metering: DtoInsideDevice['lastMetering']): ProcessedInsideDevice['lastMetering'] {
    return {
      ...metering,
      distance: Distance.centimeter(metering.distanceCm ?? 0),
      quantity: {
        unit: metering.quantity.unit,
        value: Volume.liter(metering.quantity.value),
      },
    }
  }

  private static processComputed(computed: DtoInsideDevice['computed']): ProcessedComputedStorage {
    return {
      ...computed,
      usableQuantity: {
        unit: computed.usableQuantity.unit,
        value: Volume.liter(computed.usableQuantity.value),
      },
      totalQuantity: {
        unit: computed.totalQuantity.unit,
        value: Volume.liter(computed.totalQuantity.value),
      },
    }
  }
}
